class SizeGuideDrawer extends Drawer {
  constructor() {
    super();
  }
}

class SizeGuideDrawerButton extends DrawerButton {
  constructor() {
    super();
  }
}

class SizeGuideRegion extends HTMLElement {
  constructor() {
    super();
    this.regions = [];
    this.selectedRegion = "all";
    this.areaEl = null;
    this.selectEl = null;
    this.handleRegionChange = this.handleRegionChange.bind(this);
    this.preselectLocation = false | (this.dataset.preselectLocation === "true");
  }

  connectedCallback() {
    this.selectEl = this.querySelector("select");
    this.areaEl = document.querySelector("size-guide-drawer");
    this.regions = this.getAvailableRegions();

    if (this.regions.length === 0) {
      return;
    }

    this.populateSelectElement();
    this.selectEl.addEventListener("change", this.handleRegionChange);
    
    this.preselectVisitorLocation();
    this.showRegionSelector();
  }

  disconnectedCallback() {
    this.selectEl.removeEventListener("change", this.handleRegionChange);
  }

  showRegionSelector() {
    this.classList.remove("hidden");
  }

  preselectVisitorLocation() {
    if (this.preselectLocation) {
      window.fetchVisitorBrowsingContextSuggestions().then((visitorInfo) => {
        const visitorCountryName = visitorInfo.detected_values.country.name.toLowerCase();

        if (this.regions.includes(visitorCountryName)) {
          this.filterRegions(visitorCountryName);
          this.selectEl.value = visitorCountryName;
        }

      }).catch((error) => {
        console.error('Error fetching visitor info:', error);
      });
    }
  }

  populateSelectElement() {
    this.regions.forEach((region) => {
      const option = document.createElement("option");
      option.value = region;
      // capitalize first letter of words
      region = region.replace(/\b\w/g, (char) => char.toUpperCase());
      option.textContent = region;
      this.selectEl.appendChild(option);
    });
  }

  showAllRegions() {
    const tables = this.areaEl.querySelectorAll(".size-guide-table .size-guide-table--international");
    tables.forEach((table) => {
      table.style.display = "block";
    });
  }

  filterRegions(selectedRegion) {
    const tables = this.areaEl.querySelectorAll(".size-guide-table");
    this.showAllRegions();

    selectedRegion = selectedRegion || this.selectedRegion;

    if (selectedRegion === "all") {
      return;
    }

    tables.forEach((table) => {

      if (!this.tableHasRegion(table, selectedRegion)) {
        return;
      }

      const regionColumns = table.querySelectorAll(".size-guide-table--international");

      regionColumns.forEach((regionColumn) => {
        const dataAttrLocation = regionColumn.getAttribute("data-location").toLowerCase();

        if (dataAttrLocation === selectedRegion) {
          regionColumn.style.display = "block";
        } else {
          regionColumn.style.display = "none";
        }
      });
    });
  }

  tableHasRegion(table, region) {
    return table.querySelectorAll(`[data-location="${region}" i]`).length > 0;
  }

  handleRegionChange(event) {
    this.selectedRegion = event.target.value;
    this.filterRegions();
  }

  getAvailableRegions() {
    let regions = [];
    const sizeGuideDrawer = this.areaEl;
    const tables = sizeGuideDrawer.querySelectorAll(".size-guide-table .size-guide-table--international");

    tables.forEach((table) => {
      regions.push(table.getAttribute("data-location").toLocaleLowerCase());
    });

    regions = regions.filter((region, index, self) => self.indexOf(region) === index && region !== "");

    return regions;
  }
}

class SizeGuideRegionSelect extends SizeGuideRegion {
  constructor() {
    super();
  }
}


  customElements.define("size-guide-drawer", SizeGuideDrawer);
  customElements.define("size-guide-drawer-button", SizeGuideDrawerButton);
  customElements.define("size-guide-region-select", SizeGuideRegionSelect);
